import { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
} from "@mui/material";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import SearchBar from "../../components/SearchBar";
import { useNavigate } from "react-router-dom";
import StarRating from "../../components/StarRating";

interface PromotionFeedbackTableProps {
  showPromotionColumn?: boolean;
  showUserColumn?: boolean;
}

export default function PromotionFeedbackTable({
  showPromotionColumn = true,
  showUserColumn = true,
}: PromotionFeedbackTableProps) {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  const [rows] = useState([
    {
      id: 1,
      name: "Madelyn Dias",
      email: "madelyndias@gmail.com",
      phone: "+91 9876543210",
      promotion: "Summer Sale 2025",
      feedback: "up",
      datetime: "04-Sep-2025 11:15 AM",
    },
    {
      id: 2,
      name: "Madelyn Dias",
      email: "madelyndias@gmail.com",
      phone: "+91 9876543210",
      promotion: "New User Bonus",
      feedback: "down",
      datetime: "03-Sep-2025 05:42 PM",
    },
    {
      id: 3,
      name: "Madelyn Dias",
      email: "madelyndias@gmail.com",
      phone: "+91 9876543210",
      promotion: "Festival Discount",
      feedback: "up",
      datetime: "02-Sep-2025 02:10 PM",
    },
  ]);

  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <SearchBar
            searchTerm={searchTerm}
            setDebouncedSearchTerm={setSearchTerm}
            placeholder="Search..."
          />
        </div>
      </div>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow hover>
              {showUserColumn && <TableCell>User Detail</TableCell>}
              {showUserColumn && <TableCell>Seller Detail</TableCell>}
              <TableCell>Feedback Provided</TableCell>
              {/* <TableCell>Rating</TableCell> */}
              <TableCell>Date & Time</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow hover key={row.id}>
                {showUserColumn && (
                  <TableCell>
                    <Box
                      component="a"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/manage-users/detail");
                      }}
                      className="user_block click_action"
                    >
                      <p>
                        <b>{row.name}</b>
                        <span>{row.email}</span>
                        <span>{row.phone}</span>
                      </p>
                    </Box>
                  </TableCell>
                )}
                {showUserColumn && (
                  <TableCell>
                    <Box
                      component="a"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/manage-users/detail");
                      }}
                      className="user_block click_action"
                    >
                      <p>
                        <b>{row.name}</b>
                        <span>{row.email}</span>
                        <span>{row.phone}</span>
                      </p>
                    </Box>
                  </TableCell>
                )}
                <TableCell>{"Kive aa Singh!!"}</TableCell>
                {/* <TableCell>
                  <StarRating rating={4} />
                </TableCell> */}
                <TableCell>{row.datetime}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
